import { Typography, withStyles } from '@material-ui/core';
import { Button, LoadingIcon } from 'bc-front-sagacomponents';
import React from 'react';
import { Renouvellement } from '../../../../services/Api/swagger';
import styles from '../../style';
import { usePaiementEnLigne } from './selectors';

interface Props {
  classes?: any;
  renouvellement?: Renouvellement;
  numeroAdhesion: string;
  disabledRenouvellement?: boolean;
}
const PaiementCB = (props: Props) => {
  const { classes, numeroAdhesion, renouvellement, disabledRenouvellement } = props;

  const fieldNames = [
    'vads_site_id',
    'vads_ctx_mode',
    'vads_trans_id',
    'vads_trans_date',
    'vads_amount',
    'vads_currency',
    'vads_action_mode',
    'vads_page_action',
    'vads_version',
    'vads_payment_config',
    'vads_capture_delay',
    'vads_validation_mode',
    'vads_contrib',
    'vads_cust_first_name',
    'vads_cust_last_name',
    'vads_order_id',
    'vads_url_check',
    'vads_return_mode',
    'vads_url_cancel',
    'vads_url_error',
    'vads_url_refused',
    'vads_url_success',
    'signature',
  ];

  const { formulairePaiement, fetchingPaiement, errorPaiement } = usePaiementEnLigne(
    numeroAdhesion,
    disabledRenouvellement,
    renouvellement,
  );
  return (
    <div className={classes.blocPaiementCB}>
      <form action={formulairePaiement?.url} method="post" noValidate accept-charset="UTF-8" acceptCharset="UTF-8">
        {fieldNames.map(
          (value: string) =>
            formulairePaiement && <input key={value} type="hidden" name={value} value={formulairePaiement[value]} />,
        )}
        {fetchingPaiement && <LoadingIcon size="small" />}{' '}
        {!fetchingPaiement && !errorPaiement && !disabledRenouvellement && (
          <Button
            title="Choisir"
            variant="contained"
            color="secondary"
            disabled={disabledRenouvellement}
            type="submit"
          />
        )}
        {disabledRenouvellement && (
          <Button title="Choisir" variant="contained" color="secondary" disabled={true} type="submit" />
        )}
        {errorPaiement && !disabledRenouvellement && (
          <Typography color="error">Le paiement par CB est impossible</Typography>
        )}
      </form>
    </div>
  );
};
export default withStyles(styles)(PaiementCB);
